import type { IntlShape } from 'react-intl'
import type { FlightDisplayData } from 'tripPlanner/components/Chat/flightDisplayUtils'
import type { TripDateFormatters } from 'tripPlanner/components/Chat/orderTileDisplayUtils'
import type { OrderTileData } from './bookingSelectionUtils'
import { formatUpcomingTripDateRange, getUpcomingTripTitle } from './upcomingTrips'

/** `flight` is the primary flight's fetched details, undefined until they load. */
export function buildPlanAroundTripMessage(
  intl: IntlShape,
  trip: OrderTileData,
  formatters: TripDateFormatters,
  flight?: FlightDisplayData,
): string {
  const tripName = getUpcomingTripTitle(intl, trip, flight)
  const dateRange = formatUpcomingTripDateRange(trip, formatters, flight)
  if (tripName && dateRange) {
    return intl.formatMessage(
      {
        id: 'cv50ye_22eU1J07CIPoI',
        defaultMessage: 'Plan around my {tripName} booking, {dateRange}',
        description: 'Chat message sent when the traveller asks to plan around one of their upcoming bookings, naming the booking and its dates',
      },
      { tripName, dateRange },
    )
  }

  if (tripName) {
    return intl.formatMessage(
      {
        id: 'i_AMv5cNQ2UVeAUH5b4n',
        defaultMessage: 'Plan around my {tripName} booking',
        description: 'Chat message sent when the traveller asks to plan around one of their upcoming bookings whose dates are unknown',
      },
      { tripName },
    )
  }

  return intl.formatMessage({
    id: 'uM2oMB7zRzAK9Ul4YU4l',
    defaultMessage: 'Plan around my upcoming booking',
    description: 'Chat message sent when the traveller asks to plan around one of their upcoming bookings whose name is unknown',
  })
}
